export function dateConvertStrToDate(dateStr: string) {
  return Date.parse(dateStr.replace(' ', 'T'))
}
